var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-widget" },
    [
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "", "align-center": "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-layout",
                { attrs: { "justify-space-between": "", "align-center": "" } },
                [
                  _c("v-flex", { staticClass: "body-2 long-item" }, [
                    _vm.isCombined
                      ? _c("span", { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.$t("combined")) + _vm._s(" - "))
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.condition && _vm.condition.toUpperCase() + " - "
                        ) +
                        _vm._s(_vm.name) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._t("btn")
                ],
                2
              ),
              _vm._v(" "),
              _vm.asin && _vm.asin.length !== 0
                ? _c(
                    "v-layout",
                    {
                      attrs: {
                        "justify-start": "",
                        wrap: "",
                        "align-start": ""
                      }
                    },
                    [
                      _c("span", [_vm._v("ASIN: ")]),
                      _vm._v(" "),
                      _vm._l(_vm.asin, function(item) {
                        return _c(
                          "span",
                          {
                            key: item,
                            staticClass: "ml-2",
                            attrs: { column: "" }
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://www.amazon.com/gp/product/" + item,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(item))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sku && _vm.sku.length !== 0 && _vm.isOrganization
                ? _c(
                    "v-layout",
                    {
                      attrs: {
                        "justify-start": "",
                        wrap: "",
                        "align-start": ""
                      }
                    },
                    [
                      _c("span", [_vm._v("SKU: ")]),
                      _vm._v(" "),
                      _vm._t("sku", function() {
                        return _vm._l(_vm.sku, function(item) {
                          return _c(
                            "span",
                            { key: item },
                            [
                              _vm.approvedSkuMap[item] &&
                              _vm.approvedSkuMap[item].length
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(tooltip) {
                                              return [
                                                _c(
                                                  "strong",
                                                  _vm._g(
                                                    { staticClass: "ml-2" },
                                                    tooltip.on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("approvedBy")) +
                                          ": "
                                      ),
                                      _vm._l(_vm.approvedSkuMap[item], function(
                                        warehouseKey
                                      ) {
                                        return _c(
                                          "div",
                                          { key: warehouseKey },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.warehouseKeyToNameMap[
                                                  warehouseKey
                                                ]
                                              )
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _c("div", { staticClass: "ml-2" }, [
                                    _vm._v(_vm._s(item))
                                  ])
                            ],
                            1
                          )
                        })
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "", "justify-start": "" } },
                [
                  _vm.price
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "text-sm-left",
                          attrs: { sm4: "", md3: "" }
                        },
                        [_vm._v("$ " + _vm._s(_vm.price))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.upc
                    ? _c(
                        "span",
                        { staticClass: "text-sm-left" },
                        [
                          _vm._v(
                            "\n          UPC: " +
                              _vm._s(
                                _vm.$slots.upc
                                  ? ""
                                  : _vm.isCombined
                                  ? ""
                                  : _vm.upc
                              ) +
                              "\n          "
                          ),
                          _vm._t("upc", function() {
                            return [
                              _vm.isCombined
                                ? [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "font-weight-bold"
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "primary"
                                                          }
                                                        },
                                                        [_vm._v("join_inner")]
                                                      ),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(_vm.upc) +
                                                          "\n                  "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3474207050
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("combinedUpc")) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.localQuantityPurchased !== undefined
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "", "justify-start": "" } },
                    [
                      _vm.isSupportChanged
                        ? _c(
                            "v-flex",
                            { staticClass: "text-sm-left" },
                            [
                              _c(
                                "v-edit-dialog",
                                {
                                  attrs: {
                                    "return-value": _vm.localQuantityPurchased,
                                    loading: "",
                                    large: "",
                                    lazy: "",
                                    persistent: ""
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.localQuantityPurchased = $event
                                    },
                                    "update:return-value": function($event) {
                                      _vm.localQuantityPurchased = $event
                                    },
                                    save: _vm.quantityChanged
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "input",
                                        fn: function() {
                                          return [
                                            _c("div", { staticClass: "mt-3" }, [
                                              _vm._v(
                                                _vm._s(_vm.$t("updateQuantity"))
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t("edit"),
                                                "single-line": "",
                                                autofocus: "",
                                                mask: "#######"
                                              },
                                              model: {
                                                value:
                                                  _vm.localQuantityPurchased,
                                                callback: function($$v) {
                                                  _vm.localQuantityPurchased = _vm._n(
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "localQuantityPurchased"
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3307835637
                                  )
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: !_vm.isMatchingExactly
                                          ? "white"
                                          : "black",
                                        backgroundColor: !_vm.isMatchingExactly
                                          ? "red"
                                          : ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("purchasedQty")) + ": "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.localQuantityPurchased)
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _c("v-flex", [
                            _c(
                              "span",
                              {
                                style: {
                                  color: !_vm.isMatchingExactly
                                    ? "white"
                                    : "black",
                                  backgroundColor: !_vm.isMatchingExactly
                                    ? "red"
                                    : ""
                                }
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("purchasedQty")) + ": "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.localQuantityPurchased))
                                ])
                              ]
                            )
                          ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.size && _vm.isOrganization
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "", "justify-start": "" } },
                    [
                      _c("v-flex", { staticClass: "text-sm-left" }, [
                        _vm._v(_vm._s(_vm.$t("size")) + ": " + _vm._s(_vm.size))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.quantityShipped !== undefined
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "", "justify-start": "" } },
                    [
                      _c("v-flex", { staticClass: "text-sm-left" }, [
                        _vm._v(
                          _vm._s(_vm.$t("shippedQty")) +
                            ": " +
                            _vm._s(_vm.quantityShipped)
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.orderId
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "", "justify-start": "" } },
                    [
                      _c("v-flex", { staticClass: "text-sm-left" }, [
                        _vm._v(
                          _vm._s(_vm.$t("orderId")) + ": " + _vm._s(_vm.orderId)
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.note
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-flex", {
                        directives: [
                          { name: "linkified", rawName: "v-linkified" }
                        ],
                        staticClass: "long-item",
                        style: _vm.noteStyle,
                        domProps: { textContent: _vm._s(_vm.note) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status === "canceled"
                ? _c(
                    "v-layout",
                    {
                      attrs: {
                        "justify-start": "",
                        wrap: "",
                        "align-start": ""
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { color: "red", "font-weight": "bold" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("orderStatus")) +
                              ": " +
                              _vm._s(_vm.$t(_vm.status))
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { sm1: "" } }, [_vm._v(" " + _vm._s(" "))]),
          _vm._v(" "),
          _vm._t("info")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-660e2693", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-660e2693","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductWidget.vue
// module id = null
// module chunks = 